import { FilterOperators } from "types/frontend_models/filtering/filters";

export function convertStringToFilterOperator(value: string): FilterOperators
{
	switch (value) {
		case 'eq': return FilterOperators.equals;
		case 'eqn': return FilterOperators.equalsNumber;
		case 'neq': return FilterOperators.notEquals;
		case 'ct': return FilterOperators.contains;
		case 'sw': return FilterOperators.startsWith;
		case 'lt': return FilterOperators.lessThan;
		case 'gt': return FilterOperators.greatherThan;
		case 'dr': return FilterOperators.dateRange;
		default: return FilterOperators.undefined;
	}
}

/** Converts filteroperator to sieve operator which backend expects  */
export function filterOperatorToSieveOperator(operator: FilterOperators): string
{
	switch (operator) {
		case FilterOperators.equals: return '==*';
		case FilterOperators.equalsNumber: return '==';
		case FilterOperators.notEquals: return '!=*';
		case FilterOperators.contains: return '@=*';
		case FilterOperators.startsWith: return '_=*';
		case FilterOperators.lessThan: return '<';
		case FilterOperators.greatherThan: return '>';
		case FilterOperators.undefined:
		default: return '';
	}
}